<script setup lang="ts">
import { Page } from "@/components/Ui";
import { LegalNav } from "@/components/Legal";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { computed } from "vue";
import { isMobile } from "@/helpers/breakpoints";
import { storeToRefs } from "pinia";
import { useLegalStore } from "@/store/legal";

const { fetchLegal } = useLegalStore();
const { legalItems, pending } = storeToRefs(useLegalStore());

const route = useRoute();
const { locale } = useI18n();
const localePath = useLocalePath();
const isIndex = computed(() => {
  return route.meta.key === "legal-root";
});
fetchLegal();

useHead({
  htmlAttrs: {
    class: "legal"
  }
});
definePageMeta({
  page: "legal"
});
</script>

<template>
  <Page
    :class="{
      [$style.root]: true,
      [$style.root__grid]: !isIndex,
      container: !isMobile,
    }"
  >
    <div
      v-if="!isIndex"
      class="pr-5 sticky top-[6rem] h-fit hidden xl:block order-1"
    >
      <LegalNav
        :items="legalItems"
        :pending="pending"
      />
    </div>
    <main
      class="order-2"
      :class="{ container: isMobile }"
    >
      <NuxtPage />
    </main>
    <div
      v-if="!isIndex"
      id="legal-right-col"
      class="sticky top-[3.5rem] md:top-[6rem] h-fit order-1 md:order-3 max-w-full overflow-x-auto bg-white"
    />
  </Page>
</template>

<style lang="scss" module>
.root {
  @apply md:pt-10 pb-20  mt-[70px] md:mt-[90px];
  &__grid {
    @apply grid gap-5;

    @screen md {
      grid-template-columns: auto 213px;
    }
    @screen xl {
      grid-template-columns: 250px minmax(733px, 733px) auto;
    }
  }

  & main {
    @apply w-full max-w-[733px] mx-auto;
  }
}
</style>
